"use client"

import { Button } from "@/components/ui/button"
import { InputDescription } from "../../components/InputRow/InputDescription"
import { ChevronDown } from "lucide-react"
import { SegmentsDropdown } from "./SegmentsDropdown"
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { CommunityEntry, CommunityEntryRes } from "@types"

interface ImportSubscribersDestinationProps {
  communities: CommunityEntryRes[]
  selectedSegment: CommunityEntry | null
  importInProgress: boolean
  onSegmentSelect: (segment: CommunityEntry | null) => void
  selectedSegmentId?: string
}

export function ImportSubscribersDestination({
  communities,
  selectedSegment,
  importInProgress,
  onSegmentSelect,
  selectedSegmentId,
}: ImportSubscribersDestinationProps) {
  return (
    <div className="space-y-2">
      <InputDescription>Import to</InputDescription>
      <p className="text-sm text-muted-foreground">
        Import subscribers into your publication or a specific segment. When
        importing into a segment, subscribers will be added to that segment.
        Duplicates will be skipped.
      </p>

      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={importInProgress}>
          <Button
            variant="outline"
            className="w-[350px] justify-between cursor-pointer"
          >
            {selectedSegment ? selectedSegment.name : "Publication"}
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <SegmentsDropdown
          segments={communities || []}
          onSelect={onSegmentSelect}
          selectedSegmentId={selectedSegmentId}
        />
      </DropdownMenu>
    </div>
  )
}
